module.exports = __webpack_public_path__ + "img/rafiki.289f40f6.png";